import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Button } from '@mui/material';
import Iconify from '../../../components/iconify';
import { canManageAssets } from '../../../utils/share';

const AssetHeader = ({ onCreateClick, onDashboardClick, onBulkUploadClick }) => (
  <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={1.5} mb={2.5}>
    <Button
      type="button"
      variant="outlined"
      color="inherit"
      startIcon={<Iconify icon="eva:pie-chart-2-fill" />}
      onClick={onDashboardClick}
    >
      Dashboard
    </Button>
    {canManageAssets() && (
      <>
        <Button
          type="button"
          variant="outlined"
          startIcon={<Iconify icon="solar:import-bold" />}
          onClick={onBulkUploadClick}
        >
          Import / Bulk Upload
        </Button>
        <Button type="button" variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={onCreateClick}>
          New Asset
        </Button>
      </>
    )}
  </Stack>
);

AssetHeader.propTypes = {
  onCreateClick: PropTypes.func,
  onDashboardClick: PropTypes.func,
  onBulkUploadClick: PropTypes.func,
};

export default AssetHeader;
